module.exports = __webpack_public_path__ + "static/media/hashtag-nft-10.4bff5cd6.jpg";